module.exports = __webpack_public_path__ + "img/tr.1d8f0aa6.jpg";